import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.qrCodeValue,
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isDialogVisible) = $event)),
    modal: true,
    dismissableMask: true,
    style: {"width":"650px"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: _ctx.qrCodeDataUrl,
          width: "600",
          height: "600",
          alt: _ctx.qrCodeValue
        }, null, 8, _hoisted_2)
      ])
    ]),
    _: 1
  }, 8, ["header", "visible"]))
}